import { Component, input, output } from '@angular/core';
import { TOption } from '../../components/rid-option/rid-option';
import { TKeyValue } from '../../components/rid-syllabic-keyboard/rid-syllabic-keyboard.utils';
import { RidSyllabicKeyboardAssignments } from '../rid-syllabic-keyboard-assignments/rid-syllabic-keyboard-assignments';

@Component({
  selector: 'rid-multisyllabic-keyboard-direct-rule-application',
  imports: [RidSyllabicKeyboardAssignments],
  templateUrl: './rid-multisyllabic-keyboard-direct-rule-application.html',
  host: {
    class: 'block',
  },
})
export class RidMultisyllabicKeyboardDirectRuleApplication {
  prompts = input.required<{ prompt: TOption; answer: TKeyValue[] }[]>();

  finished = output<void>();
}
